import {
  Route,
  BrowserRouter as Router,
  Routes,
  useLocation,
} from "react-router-dom";
import LoginPage from "../features/login/LoginPage";
import SignUpPage from "../features/login/SignUpPage";
import PaymentPage from "../features/payment/PaymentPage";
import InputGraphEditorPage from "../features/inputGraphEditor/InputGraphEditorPage";
import SavedDocumentsPage from "../features/home/SavedDocumentsPage";
import OutputEditorPage from "../features/outputEditor/OutputEditorPage";
import HousingTemplatePage from "../features/home/components/HousingTemplatePage";
import ApiKeysPage from "../features/apiKeys/ApiKeysPage";
import { ProtectedRoute } from "./ProtectedRoute";
import Toast from "../common-components/Toast";
import RouteTracker from "../common-components/RouterTracker";
import VerifyEmail from "../features/login/VerifyEmail";
import ForgotPassword from "../features/login/ForgotPassword";
import ResetPassword from "../features/login/ResetPassword";
import Plans from "../features/payment/Plans";
import PaymentCheck from "../features/payment/PaymentCheck";
import NewInputEditor from "../features/inputEditor/BoundaryEditorPage";
import LandingPage from "../features/landing/LandingPage";

function RoutesWithKeys() {
  const location = useLocation();

  return (
    <Routes location={location}>
      {/* Public Routes */}
      <Route path="/" element={<LoginPage />} />
      <Route path="/home" element={<LandingPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/signup" element={<SignUpPage />} />
      <Route path="/verifyemail" element={<VerifyEmail />} />
      <Route path="/forgotpass" element={<ForgotPassword />} />
      <Route path="/newinputeditor" element={<NewInputEditor />} />

      <Route
        path="reset-password/:user_id/:token"
        element={<ResetPassword />}
      />

      {/* Protected Routes */}
      <Route element={<ProtectedRoute />}>
        <Route path="/saved-documents" element={<SavedDocumentsPage />} />
        <Route path="/inputeditor" element={<InputGraphEditorPage />} />
        <Route
          path="/outputeditor"
          element={<OutputEditorPage key={location.pathname} />}
        />
        <Route path="/api-keys" element={<ApiKeysPage />} />
        <Route path="/housing-template" element={<HousingTemplatePage />} />
        <Route path="/newinputeditor" element={<NewInputEditor />} />
        <Route path="/plans" element={<Plans />} />
        <Route path="/payment" element={<PaymentPage />} />
        <Route path="/paymentcheck" element={<PaymentCheck />} />
      </Route>

      {/* Catch All Route */}
      <Route path="*" element={<div>PATH DNE</div>} />
    </Routes>
  );
}

function Home() {
  return (
    <Router>
      <RouteTracker />
      <div>
        <RoutesWithKeys />
        <Toast />
      </div>
    </Router>
  );
}

export default Home;
